import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Row, Col, Modal, Form, Spinner, Button, ListGroup } from 'react-bootstrap';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight, FaMapMarkerAlt, FaPlayCircle } from 'react-icons/fa';
import dayjs from 'dayjs';
import classNames from 'classnames';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import CamaraVisor from '../../../../../components/camaras/CamaraVisor';
import { CamarasService } from '../../../../../services/apiService';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/es'; import { flexRender, getCoreRowModel, getExpandedRowModel, getFilteredRowModel, getPaginationRowModel, useReactTable } from '@tanstack/react-table';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import IconButton from '../../../../../components/common/IconButton';
import GoogleMapSelector, { iconPunto, obtenerInfoView, obtenerInfoViewTop } from '../../../../../components/common/google-maps-selector/GoogleMapSelector';
import { obtenerIconoAlerta, obtenerImgAlerta } from '../../../../../components/common/google-maps-selector/IconosTabla';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from '../../../../../components/common/Flex';
import alertasFiltrosStore from '../../../../../lib/store/alertas_filtros_store';
import reporteTiempoStore from '../../../../../lib/store/reporte_tiempo_store';

// Activamos el soporte para formatos personalizados
// dayjs.extend(customParseFormat);
// dayjs.locale('es');

dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale('es');

// const formatFecha = (fechaStr) => {
//   if (!fechaStr || typeof fechaStr !== "string") return "N/A";
//   try {
//     // Cambio de 'hh' a 'HH' para formato de 24 horas
//     return dayjs.utc(fechaStr).local().format("DD/MM/YYYY HH:mm");

//     // O si prefieres mantener AM/PM pero corregir la conversión:
//     // return dayjs.utc(fechaStr).local().format("DD/MM/YYYY h:mm A");
//   } catch (error) {
//     console.error("Error al formatear la fecha:", error);
//     return "N/A";
//   }
// };

const formatFecha = (fechaStr) => {
    if (!fechaStr || typeof fechaStr !== 'string') return 'N/A';

    try {
        return dayjs(fechaStr, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss');
    } catch (error) {
        console.error('Error al formatear la fecha:', error);
        return 'N/A';
    }
};

// Personalizar la vista del Select
const customStyles = {
    minWidth: '70px',
    minHeight: '30px',
    maxHeight: '30px',
    fontSize: '12px',
    overflow: 'hidden',
    appearance: 'none',
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    backgroundColor: 'white',
    border: '1px solid #ccc',
    paddingRight: '20px',
    paddingLeft: '10px',
    backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' fill='lightgrey' viewBox='0 0 24 24'><path d='M12 15.41 6.41 9.83 7.83 8.41 12 12.59 16.17 8.41 17.59 9.83z'/></svg>")`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 5px center',
    backgroundSize: '25px',
};
const AlertaVehiculoTableList = ({ data = [], perPage = 5, title, isGroup, geocercas }) => {  // 🔹 Se asegura un valor predeterminado para evitar errores

    const safeTableData = Array.isArray(data) ? data : [];

    const store = reporteTiempoStore();
    // Estado para manejar el modal del mapa
    const [showMapModal, setShowMapModal] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState([]);

    // Estado del modal de video
    const [infoView, setInfoView] = useState(null);
    const [showVideoModal, setShowVideoModal] = useState(false);
    const [videoChecks, setVideoChecks] = useState([false, false, false, false]); // Inicialmente los primeros dos videos están activos
    const [selectedVehicle, setSelectedVehicle] = useState(null);
    const [urlVideo, setUrlVideo] = useState(["", "", "", ""])
    const [consultandoCamara, setConsultandoCamara] = useState([false, false, false, false])
    const [globalFilter, setGlobalFilter] = useState([]);
    // IDs de los videos
    const videoIds = ["canal-1", "canal-2", "canal-3", "canal-4"];

    // Función para abrir el modal con la latitud y longitud seleccionadas
    const handleShowMap = (data) => {
        let marcadorAlerta = obtenerMarcadorAlertas(data);
        let marcadores = obtenerMarcadoresAlerta(data);
        setSelectedLocation([marcadorAlerta, ...marcadores,]);
        setShowMapModal(true);
    };

    // Abrir modal y setear vehículo
    const handleShowVideoModal = (vehicle) => {
        setSelectedVehicle(vehicle);
        setShowVideoModal(true);
    };


    const style1Lines = {
        display: "-webkit-box",
        WebkitLineClamp: 1,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "normal",
    };
    const MySwal = withReactContent(Swal)

    const [showMarcadorModal, setShowMarcadorModal] = useState(false);
    const [contentMarcadorModal, setContentMarcadorModal] = useState([]);
    const [geocercasFiltradas, setGeocercasFiltradas] = useState([]);
    const handleShowMarcadorModal = useCallback((data) => {
        setShowMarcadorModal(true);
        setContentMarcadorModal(data);
    }, []);
    const TabTitle = ({ amount, percentage, type, updown, action }) => (
        <div className="d-flex flex-column align-items-start">
            <div className="d-flex align-items-center justify-content-start">
                <h6 className="mb-0 me-2 ">{amount}</h6>

                <FontAwesomeIcon
                    icon={(updown === undefined ? percentage : updown >= 0) ? 'caret-up' : 'caret-down'}
                    className={classNames('me-1', {
                        'text-success': type === 'up',
                        'text-danger': type === 'down',
                        'text-primary': type === 'standard',
                        'text-warning': type === 'warning',
                        'text-info': type === 'pending'
                    })}
                />


                <a
                    className={classNames({
                        'text-success': type === 'up',
                        'text-danger': type === 'down',
                        'text-primary': type === 'standard',
                        'text-warning': type === 'warning',
                        'text-info': type === 'pending'
                    })}
                    href="#!"
                    onClick={action}
                >
                    {percentage}
                </a>

            </div>


        </div>
    );

    const obtenerIcono = (tipoAlerta) => {
        var icono = obtenerIconoAlerta(tipoAlerta);
        const src = icono?.props?.src;
        return icono;
    };

    const obtenerMarcadorAlertas = (alerta, isMarkerColumn = false) => {
        var index = 0;
        if (alerta.alerta_real?.includes("Movimiento")) return null;
        index += 1;
        // let arregloFecha = (alerta.fecha || '').split(' ');
        let vehiculo = store.vehiculos.find(item => item.value === alerta.uid_vehiculo);
        if (isMarkerColumn === false) {
            setInfoView(obtenerInfoViewTop({
                markerId: index,
                titulo: (vehiculo.no_economico + " / " + vehiculo.alias) || '',
                colorFondoTitulo: alerta.color_vehiculo || 'black',
                colorTextoTitulo: 'text-white',
                velocidad: alerta.velocidad || '',
                alerta: alerta.alerta_real || '',
                fecha: dayjs(alerta.fecha).format('DD/MM/YYYY HH:mm:ss') || '',
                ruta: alerta.distancia ? (alerta.distancia).toFixed(3) : 'N/A',
                chofer: alerta.chofer || 'N/A'
            }))
        }
        return isMarkerColumn === false ? {
            lat: parseFloat(alerta.latitud),
            lng: parseFloat(alerta.longitud),
            icon: obtenerIcono(alerta.tipo_real, alerta.tipo_alerta),
            radio: alerta.radio,
            title: alerta.alerta_titulo
            /*infoView: obtenerInfoView({
                markerId: index,
                titulo: alerta.no_economico || '',
                colorFondoTitulo: alerta.color || 'black',
                colorTextoTitulo: 'text-white',
                velocidad: alerta.velocidad || '',
                alerta: alerta.alerta_real || '',
                fecha: arregloFecha.length > 0 ? arregloFecha[0] : '',
                hora: arregloFecha.length > 0 ? arregloFecha[1] : '',
                ruta: (alerta.distancia ? alerta.distancia.toFixed(3) : 'N/A'),
                chofer: alerta.chofer || 'N/A'
            }),*/
        } :
            {
                lat: parseFloat(alerta.latitud),
                lng: parseFloat(alerta.longitud),
                icon: obtenerIcono(alerta.tipo_real, alerta.tipo_alerta),
                radio: alerta.radio,
                /*infoView: obtenerInfoView({
                    markerId: index,
                    titulo: alerta.alerta_real || '',
                    colorFondoTitulo: '#5f07a3',
                    colorTextoTitulo: 'text-white',
                    ocultarBody: true
                }),*/
            };;
    };
    const obtenerMarcadoresAlerta = (rowData) => {
        const nombreGeocercas = (rowData.geoceca || '').split(',');
        const filtradas = (geocercas.filter(g => nombreGeocercas.includes(g.nombre)));
        setGeocercasFiltradas(filtradas || []);
        const arregloGeocercas = filtradas.map(g => {
            const sumaTotales = g.puntos.reduce(
                (acc, punto) => {
                    acc.lat += punto.latitud;
                    acc.lng += punto.longitud;
                    return acc;
                },
                { lat: 0, lng: 0 }
            );
            const total = g.puntos.length;
            return ({
                ...g,
                lat: sumaTotales.lat / total,
                lng: sumaTotales.lng / total
            })
        });
        const markers = [
            ...((rowData.cliente || []).map(c => {
                let alerta = {
                    latitud: c.Location.coordinates[1],
                    longitud: c.Location.coordinates[0],
                    tipo_real: 99990,
                    alerta_real: c.Nombres,
                    radio: c.Radio || 0 // Asegurarse de que radio tenga un valor por defecto
                };
                return obtenerMarcadorAlertas(alerta, true);
            }) || []),
            ...((arregloGeocercas || []).map(c => {
                let alerta = {
                    latitud: c.lat,
                    longitud: c.lng,
                    tipo_real: 99991,
                    alerta_real: c.nombre,

                };
                return obtenerMarcadorAlertas(alerta, true);
            }) || []),
            ...((rowData.referencia || []).map(c => {
                let alerta = {
                    latitud: c.Location.coordinates[1],
                    longitud: c.Location.coordinates[0],
                    tipo_real: 99992,
                    alerta_real: c.Nombres,
                    radio: c.Radio || 0 // Asegurarse de que radio tenga un valor por defecto
                };
                return obtenerMarcadorAlertas(alerta, true);
            }) || [])
        ];
        return markers;
    };
    const getLabelMarcador = (rowData) => {

        //Parametros de entrada
        const paramsEntry = {
            Clientes: (rowData.cliente || []).map(c => c.Nombres).join(',') || '',
            Geocercas: (Array.isArray(rowData.geoceca) ? rowData.geoceca.map(c => c.Nombre).join(',') || '' : (rowData.geoceca || '')),
            Referencias: (rowData.referencia || []).map(c => c.Nombres).join(',') || ''
        };

        //Obtener propiedades con valor no vacío
        const propiedadesConValor = Object.entries(paramsEntry).filter(
            ([_, valor]) => valor.trim() !== ""
        );

        //Almacena los parametros para mostrarlos en el modal
        const contentModal = propiedadesConValor.map((item, index) => {
            return (
                {
                    key: item[0],
                    value: item[1]
                }
            )
        });

        //Cantidad datos con valor
        const cantidad = Object.values(paramsEntry)
            .flatMap(str => str.split(','))
            .filter(item => item.trim() !== '') // elimina vacíos y espacios
            .length;
        const style = {
            display: "-webkit-box",
            WebkitLineClamp: 1, // Limita a 2 líneas
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
        };
        return (
            <div>
                {cantidad === 1 ? (

                    <div>
                        <strong style={style} title={`${propiedadesConValor[0][1]}`}>{propiedadesConValor[0][1]}</strong>
                        <span>{propiedadesConValor[0][0]}</span>
                    </div>

                    // <p>{propiedadesConValor[0][1]}</p>
                ) : cantidad == 0 ? (<span className="text-muted">N/A</span>) : (
                    <Col>
                        <Row >

                            <TabTitle
                                amount={`${cantidad}`}
                                percentage={'Ver'}
                                updown={1}
                                type='pending'
                                action={() => {
                                    handleShowMarcadorModal(contentModal)
                                }}
                            />
                        </Row>
                        <Row >
                            <span>Marcadores </span>
                        </Row>

                    </Col>
                )}
            </div>
        );
    };
    // Manejar visibilidad de los videos
    const handleToggleVideo = (event, index) => {

        let _urlVideo = ''

        if (event.target.checked) {

            setConsultandoCamara((prev) => {
                const items = [...prev]
                items[index] = true
                return items
            })

            const _data = CamarasService.getHistorialDeVisualizacion({
                id_camara: selectedVehicle.id_camara,
                canal: index,
                fecha_inicio_ticks: selectedVehicle.fecha_ticks,
                fecha_fin_ticks: selectedVehicle.fecha_ticks
            });

            _data.then(resp => {

                if (resp.statusCode === 200) {

                    if (resp.data !== null) {

                        _urlVideo = resp.data.url;
                    } else {

                        setVideoChecks((prev) => {
                            const newChecks = [...prev];
                            newChecks[index] = false;
                            return newChecks;
                        });

                        MySwal.fire({
                            icon: 'error',
                            text: 'No se pudo obtener la infomación',
                            showConfirmButton: true
                        })
                    }
                } else {

                    setVideoChecks((prev) => {
                        const newChecks = [...prev];
                        newChecks[index] = false;
                        return newChecks;
                    });

                    MySwal.fire({
                        icon: 'error',
                        text: resp.message,
                        showConfirmButton: true
                    })
                }

                setUrlVideo((prev) => {
                    const items = [...prev]
                    items[index] = _urlVideo
                    return items
                });

                setConsultandoCamara((prev) => {
                    const items = [...prev]
                    items[index] = false
                    return items
                })
            })
        } else {

            setUrlVideo((prev) => {
                const items = [...prev]
                items[index] = _urlVideo
                return items
            });
        }

        //console.log(urlVideo);

        setVideoChecks((prev) => {
            const newChecks = [...prev];
            newChecks[index] = !newChecks[index];
            return newChecks;
        });
    };

    // 📌 Estructura de columnas basada en el objeto `alert` de la API
    const columns = [
        {
            accessorKey: 'fecha',  // 📌 Fecha de la alerta
            header: 'Fecha',
            cell: ({ row: { original } }) => (
                <span >
                    {formatFecha(original.fecha)}
                </span>
            ),
            meta: { headerProps: {} }
        },
        {
            accessorKey: 'alerta',  // 📌 Mensaje de alerta real
            header: 'Alerta',
            cell: ({ row }) => {
                const alertaColor = row.original.color || '#888888';
                return (
                    <div className="d-flex align-items-center"  >
                        <Col md={2} className='me-2'>

                            {obtenerImgAlerta(row.original.tipo_real)}
                        </Col>
                        <Col >
                            <Row style={style1Lines} title={row.original.alerta}>
                                <strong>{row.original.alerta}</strong>
                            </Row>
                            <Row style={style1Lines} title={row.original.alerta_titulo}>
                                <span>{row.original.alerta_titulo}</span>
                            </Row>
                        </Col>
                    </div>
                );
            },
            meta: { headerProps: { className: 'text-900' } }
        },
        {
            accessorKey: 'no_economico',  // 📌 Número económico del vehículo
            header: 'Vehículo',
            cell: ({ row: { original } }) => (
                <div className='px-1' style={{ textAlign: 'left', ...style1Lines }} data-cell="vehiculo" title={original.no_economico}> {original.no_economico.substring(0, 25)} </div>
            ),
            meta: { headerProps: { className: 'text-900' } }
        },
        {
            accessorKey: 'chofer',  // 📌 Nombre del chofer
            header: 'Chofer',
            cell: ({ row: { original } }) => (
                <span >
                    {original.chofer}
                </span>
            ),
            meta: { headerProps: { className: 'text-900 text-left' } }
        },
        // {
        //     accessorKey: 'longitud',  // 📌 Longitud
        //     header: 'Longitud',
        //     meta: { headerProps: { className: 'text-900' } }
        // },
        {
            accessorKey: 'geocerca',  // 📌 Geocerca
            header: 'Marcadores',
            cell: ({ row: { original } }) => getLabelMarcador(original) || 'N/A',
            meta: { headerProps: { className: 'text-900' } }
        },
        {
            accessorKey: 'mapa',  // 📌 Mapa (icono)
            header: 'Ubicación',
            cell: ({ row: { original } }) => (
                <div className='text-center'>
                    <a
                        size="sm"
                        className="p-1"
                        href='#!'
                        onClick={() => handleShowMap(original)}
                    >
                        <FaMapMarkerAlt className="text-danger" />
                    </a>
                </div>
            ),
            meta: { headerProps: { className: 'text-900 text-center' }, cellProps: { className: 'text-center' } }
        },
        {
            accessorKey: 'video',
            header: 'Video',
            cell: ({ row: { original } }) =>
                original.vehiculo_con_camara ? (
                    original.camara_en_linea ?
                        <FaPlayCircle
                            size={24}
                            className="text-danger cursor-pointer"
                            onClick={() => handleShowVideoModal(original)}
                            style={{ cursor: 'pointer' }}
                        /> : <span className="text-muted">No disponible</span>
                ) : (
                    <span className="text-muted">N/A</span>
                ),
            meta: { headerProps: { className: 'text-900 text-center' }, cellProps: { className: 'text-center' } }
        },
    ];

    const limpiarModal = () => {

        setShowVideoModal(false)
        setVideoChecks([false, false, false, false])
    }

    const table = useReactTable({
        data: safeTableData,
        columns,
        sortable: true,
        pagination: true,
        perPage,
        getPaginationRowModel: getPaginationRowModel(),
        getCoreRowModel: getCoreRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        getSubRows: (row) => row.children,
        enableColumnFilters: false,
        initialState: {
            pagination: {
                pageSize: perPage,
            },
        },
    });

    const Filter = function ({ column, table }) {
        const firstValue = table
            .getPreFilteredRowModel()
            .flatRows[0]?.getValue(column.id)
        const columnFilterValue = column.getFilterValue()

        return typeof firstValue === "number" ? (
            <div className="flex space-x-2">
                <input
                    type="number"
                    value={columnFilterValue?.[0] ?? ""}
                    onChange={e => column.setFilterValue(old => [e.target.value, old?.[1]])}
                    placeholder={`Min`}
                    className="w-24 border shadow rounded"
                />
            </div>
        ) : (
            <input
                type="text"
                value={columnFilterValue ?? ""}
                onChange={e => column.setFilterValue(e.target.value)}
                placeholder={`Search...`}
                className="w-36 border shadow rounded"
            />
        )
    }

    return (
        <Col className="h-100">
            <div style={{ minHeight: "380px", maxHeight: "380px", overflow: "auto" }}>
                <table className='fs-10 mb-0 overflow-hidden table table-striped table-bordered'>
                    <thead className='text-nowrap align-middle'>
                        {table.getHeaderGroups().map(headerGroup => (
                            <tr key={headerGroup.id}>
                                {headerGroup.headers.map(header => {
                                    return (
                                        <th key={header.id} colSpan={header.colSpan}>
                                            {header.isPlaceholder ? null : (
                                                <div>
                                                    {flexRender(
                                                        header.column.columnDef.header,
                                                        header.getContext()
                                                    )}

                                                    {header.column.getCanFilter() ? (
                                                        <div>
                                                            <Filter column={header.column} table={table} />
                                                        </div>
                                                    ) : null}
                                                </div>
                                            )}
                                        </th>
                                    )
                                })}
                            </tr>
                        ))}
                    </thead>
                    <tbody>
                        {table.getRowModel().rows.map(row => {
                            return (
                                <tr key={row.id}>
                                    {row.getVisibleCells().map(cell => {
                                        return (
                                            <td className='form-col-label align-text-bottom' key={cell.id}>
                                                {flexRender(
                                                    cell.column.columnDef.cell,
                                                    cell.getContext()
                                                )}
                                            </td>
                                        )
                                    })}
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
                <Modal show={showMapModal} onHide={() => setShowMapModal(false)} size="lg" centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Evento: {(selectedLocation.length > 0 ? selectedLocation[0].title : '') || ''}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            {/* Sección izquierda - Mapa con marcador */}
                            <Col md={12}>
                                {infoView}
                                {selectedLocation.length > 0 ? (
                                    <GoogleMapSelector
                                        initialCenter={selectedLocation[0]}
                                        markers={selectedLocation}
                                        zoomDefault={13}
                                        mapStyle="hoper"
                                        className="vh-50"
                                        showStreetView={false}
                                        geocercas={geocercasFiltradas}
                                    />
                                ) : (
                                    <p>Ubicación no disponible</p>
                                )}
                            </Col>
                        </Row>
                    </Modal.Body>
                </Modal>

                {/* Modal de marcadores */}
                <Modal show={showMarcadorModal} onHide={() => setShowMarcadorModal(false)} size="md" centered>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <h6> Marcadores </h6>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row className="mb-3 d-flex justify-content-center">
                            <Col md={12}>
                                <ListGroup>
                                    {contentMarcadorModal && contentMarcadorModal.map((item, index) => (
                                        <ListGroup.Item>
                                            <div>
                                                <span>{item.key.toUpperCase()}</span>
                                                <br />
                                                <strong>{item.value}</strong>
                                            </div>
                                        </ListGroup.Item>
                                    ))}
                                </ListGroup>
                            </Col>
                        </Row>
                    </Modal.Body>
                </Modal>
                {/* Modal para reproducción de video */}
                <Modal show={showVideoModal} onHide={() => limpiarModal()} size="lg" centered>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <h5>No Económico: {selectedVehicle?.no_economico} </h5>
                            <h6>Fecha: {formatFecha(selectedVehicle?.fecha)} </h6>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {/* Checkboxes en la parte superior */}
                        <Row className="mb-3 d-flex justify-content-center">
                            {videoIds.map((id, index) => (
                                <Col xs="auto" key={id} className="text-center">
                                    <Form.Check
                                        id={'chk-' + id}
                                        type="checkbox"
                                        label={`Canal ${index + 1}`}
                                        checked={videoChecks[index]}
                                        onChange={(event) => handleToggleVideo(event, index)}
                                        className="fw-bold"
                                    />
                                </Col>
                            ))}
                        </Row>
                        {/* Cuadrícula de videos */}
                        <Row>
                            {videoIds.map((id, index) => (
                                <Col md={6} key={id} className="mb-3 d-flex justify-content-center">

                                    <div
                                        id={`div-` + id}
                                        className={consultandoCamara[index] ? `border p-2 text-center w-100 d-flex justify-content-center align-items-center` : `border p-2 text-center w-100`}
                                        style={{ height: '200px' }}
                                    >
                                        {consultandoCamara[index] ? <Spinner animation="border" role="status"></Spinner> : ''}
                                        {videoChecks[index] ? (
                                            <>
                                                <CamaraVisor
                                                    id={`vid-` + id}
                                                    vehiculo={selectedVehicle}
                                                    checked={videoChecks[index]}
                                                    urlVideo={urlVideo[index]}
                                                >
                                                </CamaraVisor>
                                            </>
                                        ) : (
                                            ''
                                        )}
                                    </div>

                                </Col>
                            ))}
                        </Row>
                    </Modal.Body>
                </Modal>
            </div>
            <>
                <div>
                    <Row className='justify-content-center'>
                        {/* <Col className='flex-grow-1 mt-2'>
                            <div className='d-flex align-items-center fs-10'>

                                <p className='mb-0'>

                                    <span className="d-sm-inline-block me-2">
                                        <strong>
                                            {table.getState().pagination.pageIndex + 1} - {' '}
                                            {table.getPageCount()} de {data.length}
                                        </strong>
                                    </span>
                                </p>


                                <p className="mb-0 mx-2">Página: </p>

                                <span className="flex items-center gap-1">
                                    <input
                                        type="number"
                                        min="1"
                                        max={table.getPageCount()}
                                        value={table.getState().pagination.pageIndex + 1}
                                        onChange={e => {
                                            const page = e.target.value ? Number(e.target.value) - 1 : 0
                                            table.setPageIndex(page)
                                        }}
                                        className="border p-1 rounded w-16"
                                    />
                                </span>

                                <p className="mb-0 mx-2">Paginado: </p>
                                <select
                                    style={customStyles}
                                    value={table.getState().pagination.pageSize}
                                    onChange={e => {
                                        table.setPageSize(Number(e.target.value))
                                    }}
                                >
                                    {[5, 10, 20, 30, 40, 50].map(pageSize => (
                                        <option key={pageSize} value={pageSize}>
                                            {pageSize}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </Col> */}
                        <Col  >
                            <Row >
                                <div className='pt-4 pe-4'>

                                    <div className='d-flex align-items-center justify-content-between'>
                                        <div className='d-flex align-items-center fs-10'>

                                            <span className="me-2">
                                                Total: {table.getFilteredRowModel().rows.length} | Página {table.getState().pagination.pageIndex + 1} de {table.getPageCount()}
                                            </span>
                                            <Form.Control
                                                type="number"
                                                min="1"
                                                max={table.getPageCount()}
                                                value={table.getState().pagination.pageIndex + 1}
                                                onChange={e => {
                                                    const page = e.target.value ? Number(e.target.value) - 1 : 0;
                                                    table.setPageIndex(page);
                                                }}
                                                style={{ width: '70px', height: '31px' }}
                                                size="sm"
                                            />
                                        </div>

                                        <div className='d-flex'>
                                            <Button
                                                variant="outline-dark"
                                                size="sm"
                                                className="mx-1"
                                                onClick={() => table.setPageIndex(0)}
                                                disabled={!table.getCanPreviousPage()}
                                            >
                                                <FaAngleDoubleLeft />
                                                {/* &laquo; Primera */}
                                            </Button>

                                            <Button
                                                variant="outline-dark"
                                                size="sm"
                                                className="mx-1"
                                                onClick={() => table.previousPage()}
                                                disabled={!table.getCanPreviousPage()}
                                            >
                                                <FaAngleLeft />
                                                {/* &lt; Anterior */}
                                            </Button>

                                            {/* Mostrar números de página (5 páginas alrededor de la actual) */}
                                            {(() => {
                                                // Determinar qué páginas mostrar
                                                let pagesArray = [];
                                                if (table.getPageCount() <= 5) {
                                                    // Si hay 5 o menos páginas, mostrarlas todas
                                                    pagesArray = Array.from({ length: table.getPageCount() }, (_, i) => i);
                                                } else if (table.getState().pagination.pageIndex <= 2) {
                                                    // Si estamos en las primeras páginas
                                                    pagesArray = [0, 1, 2, 3, 4];
                                                } else if (table.getState().pagination.pageIndex >= table.getPageCount() - 3) {
                                                    // Si estamos en las últimas páginas
                                                    pagesArray = [
                                                        table.getPageCount() - 5,
                                                        table.getPageCount() - 4,
                                                        table.getPageCount() - 3,
                                                        table.getPageCount() - 2,
                                                        table.getPageCount() - 1
                                                    ];
                                                } else {
                                                    // Estamos en medio, mostrar 2 antes y 2 después
                                                    pagesArray = [
                                                        table.getState().pagination.pageIndex - 2,
                                                        table.getState().pagination.pageIndex - 1,
                                                        table.getState().pagination.pageIndex,
                                                        table.getState().pagination.pageIndex + 1,
                                                        table.getState().pagination.pageIndex + 2
                                                    ];
                                                }

                                                return pagesArray.map(pageNum => (
                                                    <Button
                                                        key={`page-${pageNum}`}
                                                        variant={pageNum === table.getState().pagination.pageIndex ? "primary" : "outline-dark"}
                                                        size="sm"
                                                        className="mx-1"
                                                        onClick={() => table.setPageIndex(pageNum)}
                                                    >
                                                        {pageNum + 1}
                                                    </Button>
                                                ));
                                            })()}

                                            <Button
                                                variant="outline-dark"
                                                size="sm"
                                                className="mx-1"
                                                onClick={() => table.nextPage()}
                                                disabled={!table.getCanNextPage()}
                                            >
                                                {/* Siguiente &gt; */}
                                                <FaAngleRight />
                                            </Button>

                                            <Button
                                                variant="outline-dark"
                                                size="sm"
                                                className="mx-1"
                                                onClick={() => table.setPageIndex(table.getPageCount() - 1)}
                                                disabled={!table.getCanNextPage()}
                                            >
                                                {/* Última &raquo; */}
                                                <FaAngleDoubleRight />
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </>
        </Col>
    );
};

AlertaVehiculoTableList.propTypes = {
    tableData: PropTypes.arrayOf(
        PropTypes.shape({
            no_economico: PropTypes.string.isRequired,
            alerta_real: PropTypes.string.isRequired,
            fecha: PropTypes.string.isRequired,
            latitud: PropTypes.string,
            longitud: PropTypes.string,
            geocerca: PropTypes.string,
            chofer: PropTypes.string
        })
    ),
    perPage: PropTypes.number,
    title: PropTypes.string,
    isGroup: PropTypes.bool
};

export default AlertaVehiculoTableList;
